<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
  >
    <path
      d="M7.98013 0.858015C9.78758 0.449704 11.6732 0.599716 13.3895 1.28282L13.7305 1.42605L13.807 1.46511C14.1732 1.67514 14.3283 2.1323 14.1528 2.52631C13.9773 2.92033 13.5334 3.11145 13.1323 2.9796L13.0526 2.94867L12.7734 2.83067C11.3691 2.27174 9.82605 2.14986 8.34715 2.48399C6.76962 2.84043 5.34928 3.69678 4.29849 4.92621C3.24769 6.15565 2.62268 7.69229 2.51626 9.3061C2.40992 10.9198 2.82827 12.5246 3.70848 13.8813C4.58873 15.238 5.88368 16.2741 7.4007 16.8346C8.91776 17.3951 10.5755 17.4502 12.1265 16.9916C13.6774 16.5331 15.0383 15.5851 16.0067 14.2898C16.9749 12.9946 17.4989 11.4213 17.5 9.80414V9.03754C17.5 8.5773 17.8731 8.20421 18.3333 8.20421C18.7936 8.20421 19.1667 8.5773 19.1667 9.03754V9.80414L19.1593 10.1744C19.0838 12.0202 18.4516 13.8033 17.3421 15.2875C16.1586 16.8707 14.4948 18.0295 12.5993 18.5899C10.7037 19.1504 8.67713 19.0829 6.8229 18.3979C4.96892 17.7129 3.38619 16.4467 2.31037 14.7887C1.23451 13.1304 0.722819 11.1686 0.85285 9.19623C0.982901 7.22396 1.74728 5.34644 3.0314 3.84386C4.31572 2.34121 6.05201 1.29365 7.98013 0.858015ZM17.7441 2.5434C18.0694 2.21809 18.597 2.21822 18.9225 2.5434C19.2478 2.8687 19.2477 3.39628 18.9225 3.72179L10.5892 12.0633C10.4329 12.2195 10.221 12.3073 9.99999 12.3074C9.77898 12.3074 9.56707 12.2195 9.41079 12.0633L6.91079 9.56326L6.85383 9.50059C6.58655 9.17328 6.60558 8.69008 6.91079 8.38487C7.21587 8.0799 7.69843 8.06106 8.0257 8.3279L8.08918 8.38487L9.99999 10.2957L17.7441 2.5434Z"
      fill="url(#paint0_linear_19049_1889)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_19049_1889"
        x1="3.17148"
        y1="2.50355"
        x2="16.2198"
        y2="17.7971"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#472CE8" />
        <stop
          offset="1"
          stop-color="#39D87D"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
